import { _fetch } from "../helpers/_fetch";

const type = "/auth/v1";

const AuthencationAPI = {
  login: paramBody => {
    let body = {
      method: "POST",
      body: paramBody
    };
    return _fetch(`${type}/login/admin`, body, true);
  },
  verify: paramBody => {
    let body = {
      method: "POST",
      body: paramBody,
      withAuth: false
    };
    return _fetch(`${type}/verify`, body, true);
  },
  resendCode: paramBody => {
    let body = {
      method: "POST",
      body: paramBody,
      withAuth: false
    };

    return _fetch(`${type}/resend_code`, body, true);
  },
  setPassword: paramBody => {
    let body = {
      method: "POST",
      body: paramBody
    };

    return _fetch(`${type}/password`, body);
  },
  changePassword: paramBody => {
    let body = {
      method: "PUT",
      body: paramBody
    };

    return _fetch(`${type}/password`, body);
  }
};

export default AuthencationAPI;
